<div class="container-mat">
  <pos-navbar *ngIf="!(isNavBarHidden$ | async)" [drawerStatus]="drawerStatus"></pos-navbar>
  <pos-footer *ngIf="!(isFooterHidden$ | async)"></pos-footer>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate"></ngx-spinner>
</div>
